import { render, staticRenderFns } from "./ShowcaseSection.vue?vue&type=template&id=47f831d4&scoped=true"
import script from "./ShowcaseSection.vue?vue&type=script&lang=js"
export * from "./ShowcaseSection.vue?vue&type=script&lang=js"
import style0 from "./ShowcaseSection.vue?vue&type=style&index=0&id=47f831d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f831d4",
  null
  
)

export default component.exports